/** @format */

export class RangeHelper {
    private readonly LTE = 'lte';
    private readonly GTE = 'gte';
    private readonly LT = 'lt';
    private readonly GT = 'gt';
    private readonly EQ = 'eq';

    private readonly LTE_R = '<=';
    private readonly GTE_R = '>=';
    private readonly LT_R = '<';
    private readonly GT_R = '>';

    parseValue = (value: string): string => {
        let query = this.getValue(this.LTE_R, this.LTE, value);
        if (query) {
            return query;
        }
        query = this.getValue(this.GTE_R, this.GTE, value);
        if (query) {
            return query;
        }
        query = this.getValue(this.LT_R, this.LT, value);
        if (query) {
            return query;
        }
        query = this.getValue(this.GT_R, this.GT, value);
        if (query) {
            return query;
        }
        if (value && value.length > 0) {
            return this.EQ + value;
        }
        return '';
    };

    private getValue = (search: string, replace: string, value: string): string | null => {
        const index = value.indexOf(search);
        if (index !== -1) {
            const query = value.slice(index + search.length).trim();
            if (query.length > 0) {
                return replace + query;
            }
            return '';
        }
        return null;
    };
}
